import {
    Box,
    Button,
    ButtonProps,
    Checkbox,
    Container,
    FormControl,
    FormControlLabel,
    FormGroup,
    FormLabel,
    Link,
    styled,
    SvgIcon,
    TextField,
    Typography,
  } from "@mui/material";
  import React from "react";
  import variables from "../../../assets/styles/variables.module.scss";
  
  const MicrosoftSvgIcon = (props: any) => (
    <SvgIcon {...props}>
      <rect x="0" y="0" width="11.5" height="11.5" fill="#F25022" />
      <rect x="12.5" y="0" width="11.5" height="11.5" fill="#7FBA00" />
      <rect x="0" y="12.5" width="11.5" height="11.5" fill="#00A4EF" />
      <rect x="12.5" y="12.5" width="11.5" height="11.5" fill="#FFB900" />
    </SvgIcon>
  );
  
  interface MyComponentProps {}
  
  const ColorButton = styled(Button)<ButtonProps>(({ theme }) => ({
    // borderRadius: "8px",
    color: variables.whiteColor,
    backgroundColor: variables.primaryColor,
    "&:hover": {
      backgroundColor: variables.secondaryColor,
    },
  }));
  
  const AuthCommon: React.FC<MyComponentProps> = ({}) => {
    return (
      <>
        
          <Box
            sx={{
              display: "flex",
              width: "100%",
              px: {xl:15, lg:15, md: 8, sm: 8, xs: 5},
              py:{sm: 6, xs: 3},
              alignItems:"center",
              background: "rgba(233, 250, 254, 0.5)",
            }}
          >
            <Box
              sx={{
                display:"flex",
                flexDirection:"column",
                gap: 1,
              }}
            >
              <Typography
                fontWeight="900"
                sx={{
                  fontSize: { lg: "38px", md: "38px", sm: "30px", xs: "28px" },
  
                }}
              >
                Build personalized AI agents for your Business Units
              </Typography>
              <ul
                style={{
                  paddingLeft: "18px",
                }}
              >
                <li>
                  <Typography
                    fontWeight="500"
                    sx={{
                      color: variables.textColor2,
                      fontSize: { lg: "16px" },
                    }}
                  >
                    Leverage your own LLM API keys (OpenAI, Gemini, Claude,
                    Nvidia).
                  </Typography>
                </li>
                <li>
                  <Typography
                    fontWeight="500"
                    sx={{
                      color: variables.textColor2,
                      fontSize: { lg: "16px" },
                    }}
                  >
                    Train and deploy your own local LLM models (Llama, Falcon,
                    Flux etc).
                  </Typography>
                </li>
                <li>
                  <Typography
                    fontWeight="500"
                    sx={{
                      color: variables.textColor2,
                      fontSize: { lg: "16px" },
                    }}
                  >
                    Create a powerful chatbot agent in just 5 minutes.
                  </Typography>
                </li>
                <li>
                  <Typography
                    fontWeight="500"
                    sx={{
                      color: variables.textColor2,
                      fontSize: { lg: "16px" },
                    }}
                  >
                    Enterprise-ready with Microsoft Azure OpenAI support.
                  </Typography>
                </li>
                <li>
                  <Typography
                    fontWeight="500"
                    sx={{
                      color: variables.textColor2,
                      fontSize: { lg: "16px" },
                    }}
                  >
                    SOC2 compliant for robust data security
                  </Typography>
                </li>
              </ul>
            </Box>
          </Box>
  
         
      </>
    );
  };
  export default AuthCommon;
  